import { gradingTypes, priorityTypes } from "../utils/gradingTypes";

export const PRODUCT_KEYS = ["premium", "no_subgrades", "pre", "cert_only", "raw", "standard"];
export const PRIORITY_KEYS = ["none", "low", "mid", "high", "max"];
export const PRODUCT_LABELS = gradingTypes;
export const PRIORITY_LABELS = priorityTypes;

export const PRODUCT_FIELD_LABELS = {
    baseCents: "Preço base (centavos)",
    active: "Ativo",
    withSubgradesCents: "Preço do lacre com subgrades",
    withoutSubgradesCents: "Preço do lacre sem subgrades",
};

export const PRIORITY_FIELD_LABELS = {
    additionalRate: "Adicional sobre a base",
    daysPerItem: "Dias por item",
    discountPerItem: "Desconto por item",
    maxDiscount: "Desconto máximo",
    minDeadlineDays: "Prazo mínimo (dias úteis)",
    maxItems: "Teto de itens",
    hubItemsPerCase: "Itens por caixa (HUB)",
    active: "Ativo",
};

export const FEE_FIELD_LABELS = {
    handlingFeeRate: "Taxa de manuseio",
    autographCents: "Adicional de autógrafo",
};

export const FIELD_LABELS = {
    ...PRODUCT_FIELD_LABELS,
    ...PRIORITY_FIELD_LABELS,
    ...FEE_FIELD_LABELS,
};
